var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.16667 33.3333C3.02084 33.3333 2.03959 32.925 1.22292 32.1083C0.406253 31.2917 -0.00138535 30.3111 3.53707e-06 29.1667V22.9167H4.16667V29.1667H29.1667V22.9167H33.3333V29.1667C33.3333 30.3125 32.925 31.2937 32.1083 32.1104C31.2917 32.9271 30.3111 33.3347 29.1667 33.3333H4.16667ZM16.6667 25L6.25 14.5833L9.16667 11.5625L14.5833 16.9792V0H18.75V16.9792L24.1667 11.5625L27.0833 14.5833L16.6667 25Z",
    fill: "#38B6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.46ec9d6bf0308050288af9f598b8e483.svg";
export { ForwardRef as ReactComponent };